<template lang="pug">
  v-dialog(v-model="showDialog" max-width="500px" persistent scrollable :fullscreen="$vuetify.breakpoint.mdAndDown" )
    v-card(align="center")
      v-card-title {{ $t('sendEmailDialog.deleteTemplateTitle') }}
      v-row.ma-0.align-self-center(align="center" )
        v-card-text.text-center {{ $t('sendEmailDialog.deleteDialogTitle') }} {{this.selectedItemValue.name}}?
      v-divider
      v-card-actions
        v-spacer
        v-btn.mr-2(@click="onCloseButtonClick" text) {{ $t('sendEmailDialog.no') }}
        v-btn.mr-2(@click="onSubmitButtonClick" color="primary" :loading="confirmDelete") {{ $t('sendEmailDialog.yes') }}



</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import {MessageTemplateList} from "@/model/MessageTemplateList";

@Component({})

export default class ControlDeleteMessageDialog extends Vue {


  @Prop({ type: Boolean, default: false }) readonly showDialog!: boolean
  @Prop({ type: Object, default: false }) readonly selectedItemValue!: MessageTemplateList

  private confirmDelete: boolean = false


  onCloseButtonClick (): void {
    this.$emit('close')
  }

  onSubmitButtonClick (): void {
    this.confirmDelete = true
    this.$emit('delete',this.selectedItemValue)
  }


  mounted () {
  }
}

</script>

<style lang="stylus" scoped>
.card-body
  overflow auto
</style>